import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, makeStyles, Container, FormControl, TextField, RadioGroup, FormControlLabel, Radio, FormLabel, Snackbar } from '@material-ui/core';
import GoogleSheetsService from '../services/GoogleSheetsService';
import { useParams } from 'react-router-dom';
import { sendDataToGoogleSheet } from '../services/GuiDuLieuService';
import CustomAlert from '../component/CustomAlert';
import FullScreenLoading from '../component/FullScreenLoading';

const useStyles = makeStyles((theme) => ({
    root: {
        // padding: theme.spacing(3),
        // backgroundColor: '#f4f6f8', // Màu nền trang
        textAlign: 'center',
        marginTop: theme.spacing(5)

    },
    title1: {
        fontSize: '3rem', // Kích thước chữ lớn
        fontWeight: 'bold',
        marginBottom: theme.spacing(2), // Khoảng cách dưới tiêu đề
        color: '#00095b !important'
    },
    title2: {
        marginBottom: theme.spacing(5),
    },
    boxForm: {
        display: 'flex',
        flexDirection: 'column', // Xếp các FormControl theo cột
        alignItems: 'center',    // Căn giữa các FormControl theo chiều ngang
        width: '100%',          // Giới hạn chiều rộng tối đa cho boxForm (tùy chọn)
        margin: '0 auto',        // Căn giữa boxForm trên màn hình
        padding: theme.spacing(2), //
    },
    formControl: {
        width: '50%',
        margin: theme.spacing(1.5),
        [theme.breakpoints.down('sm')]: {
            width: '90%', // Trên màn hình nhỏ hơn, cho FormControl rộng hơn
        },
        textAlign: 'left'
    },
    button: {
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1565c0',
        },
    },

}));

const BaoGiaPage = () => {
    const classes = useStyles();
    const { name } = useParams();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async (sheetName) => {
            try {
                const data = await GoogleSheetsService.getData(sheetName, 'A:B');

                const fordData = data.find(item => item.tenLink === name);
                console.log(fordData);
                setData(fordData);;
            } catch (err) {
            }
        };

        fetchData('loaixe');
    }, [name]);

    const [formData, setFormData] = React.useState({
        hoTen: '',
        soDienThoai: '',
        email: '',
        thanhpho: 'Thái Nguyên',
        daily: 'Thái Nguyên Ford',
        xe: data.ten,
        hinhThuc: 'Trả góp',
    });

    // State để lưu trữ lỗi validation
    const [errors, setErrors] = useState({
        hoTen: false,
        soDienThoai: false,
        formOverall: '', // Lỗi tổng thể của form
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        // Xóa lỗi khi người dùng bắt đầu nhập lại
        if (errors[name]) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: false,
            }));
        }
        // Xóa lỗi tổng thể nếu có
        if (errors.formOverall) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                formOverall: '',
            }));
        }
    };

    const GOOGLE_APP_SCRIPT_WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbwCF_OdEm_HoqFLNZF_P614ORKuhKDsXsfNrtES1uEzauBcbJNFfJ53dEFotDp0K4MN/exec';
    const TARGET_SHEET_NAME = 'yeu-cau-bao-gia';
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        let newErrors = {
            hoTen: false,
            soDienThoai: false,
            formOverall: '',
        };
        let isValid = true;

        // Kiểm tra trường Họ và tên
        if (!formData.hoTen.trim()) {
            newErrors.hoTen = true;
            isValid = false;
        }

        // Kiểm tra trường Số điện thoại
        if (!formData.soDienThoai.trim()) {
            newErrors.soDienThoai = true;
            isValid = false;
        }

        setErrors(newErrors);

        if (isValid) {
            try {
                const body = {
                    ...formData,
                    xe: data.ten
                }
                await sendDataToGoogleSheet(GOOGLE_APP_SCRIPT_WEB_APP_URL, body, TARGET_SHEET_NAME);
                console.log(body);
                setSnackbar({
                    open: true,
                    message: 'Yêu cầu của bạn đã được gửi thành công!',
                    severity: 'success',
                });
                setFormData({
                    hoTen: '',
                    soDienThoai: '',
                    email: '',
                    thanhpho: 'Thái Nguyên',
                    daily: 'Thái Nguyên Ford',
                    xe: data.ten,
                    hinhThuc: 'Trả góp',
                });
            } catch (error) {
                // Xử lý lỗi nếu hàm sendDataToGoogleSheet ném lỗi
                console.error('Lỗi khi gửi form:', error);
                setSnackbar({
                    open: true,
                    message: `Có lỗi xảy ra: ${error.message}. Vui lòng thử lại.`,
                    severity: 'error',
                });
            } finally {
                setLoading(false);
            }
        } else {
            newErrors.formOverall = 'Vui lòng điền đầy đủ các trường bắt buộc.';
            setErrors(newErrors);
            console.log('Form Data không hợp lệ. Vui lòng kiểm tra lại.');
        }
    };
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <>
            <Container maxWidth='lg'>
                <Box className={classes.root}>
                    <Typography variant="h2" className={classes.title1}>
                        Yêu cầu báo giá {data.ten}
                    </Typography>
                    <Typography variant="body1" className={classes.title2}>
                        Hãy đăng ký để nhận được thêm thông tin về giá và các chương trình khuyến mãi mới nhất về <strong>{data.ten}</strong>.
                    </Typography>
                    <Typography variant="h2" className={classes.title1}>
                        Thông tin liên hệ
                    </Typography>

                    <form onSubmit={handleSubmit}>
                        <Box className={classes.boxForm}>
                            {errors.formOverall && (
                                <Typography
                                    color="error"
                                    variant="body2"
                                    sx={{ mb: 2 }}
                                // className={classes.errorText} // Nếu dùng makeStyles
                                >
                                    {errors.formOverall}
                                </Typography>
                            )}
                            <FormControl className={classes.formControl} error={errors.hoTen}>
                                <TextField
                                    label="Họ và tên"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="hoTen"
                                    value={formData.hoTen}
                                    onChange={handleChange}
                                    required
                                    error={errors.hoTen}
                                    helperText={errors.hoTen ? 'Họ và tên không được để trống' : ''}
                                />
                            </FormControl>
                            <FormControl className={classes.formControl} error={errors.soDienThoai}>
                                <TextField
                                    label="Số điện thoại"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="soDienThoai"
                                    value={formData.soDienThoai}
                                    onChange={handleChange}
                                    required
                                    error={errors.soDienThoai}
                                    helperText={errors.soDienThoai ? 'Số điện thoại không được để trống' : ''}
                                />
                            </FormControl>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </FormControl>

                            <FormControl className={classes.formControl}>
                                <TextField
                                    label="Thành Phố"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="thanhpho"
                                    value='Thái Nguyên'
                                    disabled
                                />
                            </FormControl>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    label="Đại lý"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="daily"
                                    value='Thái Nguyên Ford'
                                    disabled
                                />
                            </FormControl>
                            <FormControl className={classes.formControl}>
                                <FormLabel className={classes.formLabel}>Hình thức:</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="hinhThuc"
                                    value={formData.hinhThuc}
                                    onChange={handleChange}
                                    row
                                >
                                    <FormControlLabel value="Trả góp" control={<Radio />} label="Trả góp" />
                                    <FormControlLabel value="Trả hết" control={<Radio />} label="Trả hết" />
                                </RadioGroup>
                            </FormControl>
                            <Box sx={{ textAlign: 'center' }}>
                                <Button type="submit" variant="contained" className={classes.button} fullWidth>
                                    Gửi yêu cầu
                                </Button>
                            </Box>
                        </Box>

                        <Snackbar
                            open={snackbar.open}
                            autoHideDuration={6000}
                            onClose={handleCloseSnackbar}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        >
                            <CustomAlert message={snackbar.message} onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }} />
                        </Snackbar>
                    </form>

                </Box >
            </Container >
            {loading && <FullScreenLoading />}
        </>
    );
};

export default BaoGiaPage;
